// src/pages/ComediesPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { fetchUserProfile, fetchComedyMovies } from '../../services/api';

const ComediesPage = () => {
  const [userProfile, setUserProfile] = useState(null);
  const [movies, setMovies] = useState([]);

  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    () => JSON.parse(localStorage.getItem('sidebarCollapsed')) || false
  );

  useEffect(() => {
    localStorage.setItem(
      'sidebarCollapsed',
      JSON.stringify(sidebarCollapsed)
    );
  }, [sidebarCollapsed]);

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('authToken');

    const loadUserProfile = async () => {
      try {
        const profile = await fetchUserProfile(token);
        setUserProfile(profile);
      } catch (err) {
        console.error('Error fetching user profile:', err);
      }
    };

    const loadMovies = async () => {
      try {
        const data = await fetchComedyMovies('newest');
        setMovies(data);
      } catch (err) {
        console.error('Error fetching comedy movies:', err);
      }
    };

    loadUserProfile();
    loadMovies();
  }, []);

  const handleOrderingChange = async (e) => {
    try {
      const data = await fetchComedyMovies(e.target.value);
      setMovies(data);
    } catch (err) {
      console.error('Error fetching comedy movies:', err);
    }
  };

  return (
    <div className="dashboard-background">
      <div className="container-fluid">
        <div className="d-flex">

          <Sidebar
            userProfile={userProfile}
            isCollapsed={sidebarCollapsed}
            setIsCollapsed={setSidebarCollapsed}
          />

          <main
            className="flex-grow-1 px-4"
            style={{
              minHeight: '100vh',
              marginLeft: sidebarCollapsed ? '60px' : '220px'
            }}
          >

            {/* HEADER */}
            <div className="text-center mb-4">
              <img
                src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736174973/image-removebg-preview_1_rez4gn.png"
                alt="Logo"
                style={{
                  width: '100px',
                  height: '100px'
                }}
              />

              <h1 className="fw-bold d-inline mb-0">
                Comedy Movies
              </h1>
            </div>

            {/* SORT */}
            <div className="d-flex justify-content-end mb-4">
              <select
                className="form-select w-auto"
                defaultValue="newest"
                onChange={handleOrderingChange}
              >
                <option value="title_asc">A → Z</option>
                <option value="title_desc">Z → A</option>
                <option value="newest">Newest</option>
                <option value="oldest">Oldest</option>
              </select>
            </div>

            {/* GRID */}
            <div className="row g-4">
              {movies.map((movie) => (
                <div
                  key={movie.id}
                  className="col-6 col-md-4 col-lg-3"
                >
                  <div
                    className="card h-100 shadow-sm border-0"
                    style={{
                      cursor: 'pointer',
                      backgroundColor: '#ffffff',
                      borderRadius: '18px',
                      border: '1px solid #e5e7eb',
                      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                      transition: '0.2s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform =
                        'translateY(-8px)';
                      e.currentTarget.style.backgroundColor =
                        '#dbeafe';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform =
                        'translateY(0px)';
                      e.currentTarget.style.backgroundColor =
                        '#ffffff';
                    }}
                    onClick={() =>
                      navigate(`/comedies/${movie.id}`)
                    }
                  >

                    {/* MOVIE POSTER */}
                    <img
                      src={movie.image}
                      className="card-img-top"
                      alt={movie.title}
                      style={{
                        width: '100%',
                        height: '320px',
                        objectFit: 'cover',
                        borderRadius: '18px 18px 0 0'
                      }}
                    />

                    <div className="card-body text-center">
                      <h6
                        className="fw-bold mb-1"
                        style={{ fontSize: '20px' }}
                      >
                        {movie.title}
                      </h6>
                    </div>

                  </div>
                </div>
              ))}
            </div>

          </main>
        </div>
      </div>
    </div>
  );
};

export default ComediesPage;